import axios from '../utils/axios';

export default function postCompetitionAction(adminId, data) {
    
    return (
        axios.post('/admin/'+adminId + '/competition/v2/competition/admin/bulkaction', data)
    )
}
